import {
	BannerCountry,
	useCountryBanner,
} from "shared-components/Components/Banners/BannerArgentoInvest/web";

import { BannerProptech } from "shared-components/Components/Banners/BannerProptech/web";
import { MetaTags } from "../../Components/SEO/web";
import { RTBhouse } from "../../Components/RTBhouse/web";
import React from "react";
import dynamic from "next/dynamic";
import { useFacebookPixel } from "../../GlobalHooks/web/FacebookPixel.hook";
import { useGoogleAnalytics } from "../../GlobalHooks/web/GoogleAnalytics.hook";
import { useGoogleTagManager } from "../../GlobalHooks/web/GoogleTagManager.hook";
import { useOneSignal } from "../../GlobalHooks/web/OneSignal.hook";
import dayjs from "dayjs";
import { BannerPIP } from "shared-components/Components/Banners/BannerPIP/web";

const BannerAppPromotion = dynamic(
	(): any =>
		import("../../Components/Banners/BannerAppPromotion/web").then(
			mod => mod.BannerAppPromotion
		),
	{ ssr: false }
);

const BannerPopUp = dynamic(
	(): any => import("../../Components/Banners/BannerPopUp/web").then(mod => mod.BannerPopUp),
	{ ssr: false }
);

const BannerLatamInvierte = dynamic(
	(): any =>
		import("../../Components/Banners/BannerLatamInvierte/web").then(
			mod => mod.BannerLatamInvierte
		),
	{ ssr: false }
);



const GlobalComponents = ({ children }) => {
	useFacebookPixel(true);
	useGoogleAnalytics(true);
	useGoogleTagManager(true);
	useOneSignal(true);

	const { bannerToShow } = useCountryBanner();

	const START_TIME = dayjs("31/03/2022 10:00", "DD/MM/YYYY HH:mm")
	const END_TIME = dayjs("31/03/2022 11:30", "DD/MM/YYYY HH:mm")
	const hidePopup = dayjs().isAfter(START_TIME, "minute") && dayjs().isBefore(END_TIME, "minute")

	return (
		<>
			<MetaTags />
			{children}

			{bannerToShow !== "normal" && <BannerCountry bannerToShow={bannerToShow} />}
			{!hidePopup && bannerToShow == "normal" && <BannerPopUp />}
			<BannerLatamInvierte />
			<BannerPIP
				LS_KEY={"open-day-virtual-osaka-austin"}
				START_TIME={START_TIME}
				END_TIME={END_TIME}
				videoID={"ZRT-LLrcxM0"}
				subtitle={"¡Open Day Virtual - Casas en Carrasco o Apartamentos <span style='white-space:nowrap'>La Blanqueada</span> con 8% OFF!"}
				queryParam={"PIP-OD-osaka-austin"}
			/>
			<BannerProptech />

			<RTBhouse />
			<BannerAppPromotion />
		</>
	);
};

export function withGlobalComponents(PageComponent) {
	const withGlobalComponents = ({ children, ...pageProps }) => {
		return (
			<GlobalComponents>
				<PageComponent {...pageProps}>{children}</PageComponent>
			</GlobalComponents>
		);
	};

	if (PageComponent.getInitialProps) {
		withGlobalComponents.getInitialProps = async ctx => {
			let pageProps = {};
			if (PageComponent.getInitialProps) pageProps = await PageComponent.getInitialProps(ctx);
			return { ...pageProps };
		};
	}

	return withGlobalComponents;
}
